import React, { lazy, Suspense } from "react";
import StatusMessage from "assets/scripts/components/presentational/StatusMessage";
import track from "react-tracking";
const Settlement = lazy(() => import("./Settlement"));
const SettlementWrapper = (props) => (<div className="wrapper wrapper_medium">
		<Suspense fallback={(<StatusMessage isLoad isActive/>)}>
			<Settlement {...props}/>
		</Suspense>
	</div>);
export default track({ page: "Settlement" }, { dispatchOnMount: true })(SettlementWrapper);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Settlement/SettlementWrapper.tsx